@if (totalCount >= 1) {
  <div>
    <p-table [value]="processes" dataKey="id" [showCurrentPageReport]="true">
      <ng-template pTemplate="header">
        <tr class="tw-text-sm">
          <th>ID</th>
          <th>Sistema</th>
          <th>Empresa</th>
          <th>Nome</th>
          <th>Status</th>
          <th>Data de criação</th>
          <th>Data de alteração</th>
          <th>Detalhes</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-process>
        <tr class="tw-text-sm">
          <td>{{ process.id }}</td>
          <td>{{ process.system.name }}</td>
          <td>{{ process.system.company.name }}</td>
          <td>
            <span class="ml-1 vertical-align-middle">
              {{ process.name }}
            </span>
          </td>
          <td>
            <hub-status [status]="process.status" />
          </td>
          <td>{{ process.createdAt | date: 'dd/MM/yyyy - HH:mm' : 'UTC' }}</td>
          <td>{{ process.updatedAt | date: 'dd/MM/yyyy - HH:mm' : 'UTC' }}</td>
          <td>
            <p-button
              class="tw-flex"
              (onClick)="detail(process.id)"
              [rounded]="true"
              [text]="true"
              icon="pi pi-info-circle"
              pTooltip="Detalhes"
              tooltipPosition="left" />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="tw-flex tw-justify-center">
    <p-paginator
      (onPageChange)="search($event)"
      [first]="first"
      [rowsPerPageOptions]="[10, 15, 20, 30, 50]"
      [rows]="rows"
      [totalRecords]="totalCount" />
  </div>
}
@defer (when totalCount < 1) {
  <div class="tw-bg-slate-100 tw-w-full tw-rounded tw-m-auto tw-p-4 tw-mb-4">
    <h1 class="tw-text-center tw-text-sm tw-text-slate-500">Nenhum resultado encontrado</h1>
  </div>
} @loading (minimum 500ms) {
  <hub-table-skeleton />
}
